import React from 'react';
import { NonSubscriberLoadingAnimation } from '@/components/NonSubscriberLoadingAnimation';
import Navigation from '@/components/Navigation';
import Footer from '@/components/ui/footer';

export default function DemoNonSubscriberPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-teal-50">
      <Navigation />
      <div className="container mx-auto py-8 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <h1 className="text-4xl font-bold bg-gradient-to-r from-purple-600 via-teal-600 to-amber-600 bg-clip-text text-transparent mb-4">
              Non-Subscriber Loading Animation Demo
            </h1>
            <p className="text-xl text-gray-700">
              This page demonstrates the loading animation shown to non-subscribers
            </p>
          </div>

          <div className="grid gap-8 lg:grid-cols-2">
            {/* With upgrade prompt */}
            <div className="bg-gradient-to-br from-white to-purple-50 rounded-3xl shadow-xl border border-purple-100 p-8">
              <h2 className="text-2xl font-bold text-center mb-6 text-purple-800">
                With Upgrade Prompt
              </h2>
              <NonSubscriberLoadingAnimation 
                message="Subscription required for story generation"
                showUpgradePrompt={true}
              />
            </div>

            {/* Without upgrade prompt */}
            <div className="bg-gradient-to-br from-white to-teal-50 rounded-3xl shadow-xl border border-teal-100 p-8">
              <h2 className="text-2xl font-bold text-center mb-6 text-teal-800">
                Without Upgrade Prompt
              </h2>
              <NonSubscriberLoadingAnimation 
                message="Checking subscription status..."
                showUpgradePrompt={false}
              />
            </div>
          </div>

          <div className="mt-12 bg-gradient-to-r from-amber-50 to-orange-50 rounded-2xl p-8 border border-amber-200">
            <h3 className="text-2xl font-bold text-center mb-4 text-amber-800">
              Features of the Non-Subscriber Animation
            </h3>
            <div className="grid gap-4 md:grid-cols-2">
              <div className="space-y-3">
                <h4 className="font-semibold text-amber-700">Visual Elements</h4>
                <ul className="space-y-2 text-sm text-amber-600">
                  <li>• Same graphics and animations as story generation</li>
                  <li>• Lock icon overlay on the logo</li>
                  <li>• Floating sparkles and teddy bear animation</li>
                  <li>• Premium features preview</li>
                  <li>• Gender-based logo selection</li>
                </ul>
              </div>
              <div className="space-y-3">
                <h4 className="font-semibold text-amber-700">Interactive Elements</h4>
                <ul className="space-y-2 text-sm text-amber-600">
                  <li>• Subscribe Now button (links to /subscribe)</li>
                  <li>• View Plans button (links to /pricing)</li>
                  <li>• Pricing information display</li>
                  <li>• Encouraging messaging</li>
                  <li>• Responsive design</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}